var _rect, _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FCE8AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9739 11.1162L9.89186 19.6002C9.78708 19.7817 9.73164 19.9874 9.73105 20.1969C9.73047 20.4065 9.78475 20.6125 9.88852 20.7945C9.99228 20.9766 10.1419 21.1283 10.3225 21.2345C10.5031 21.3408 10.7083 21.3979 10.9179 21.4002H21.0819C21.2914 21.3979 21.4966 21.3408 21.6772 21.2345C21.8578 21.1283 22.0074 20.9766 22.1112 20.7945C22.215 20.6125 22.2693 20.4065 22.2687 20.1969C22.2681 19.9874 22.2126 19.7817 22.1079 19.6002L17.0259 11.1162C16.9189 10.9399 16.7683 10.7941 16.5886 10.6929C16.4089 10.5917 16.2061 10.5386 15.9999 10.5386C15.7936 10.5386 15.5909 10.5917 15.4111 10.6929C15.2314 10.7941 15.0808 10.9399 14.9739 11.1162V11.1162Z",
    stroke: "#5C5C5C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.2V16.6",
    stroke: "#5C5C5C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 18.9999,
    r: 0.3,
    stroke: "#5C5C5C",
    strokeWidth: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/WarningCircle.a2a62a2323c4075a4f4c7b7df70e25ea.svg";
export { ForwardRef as ReactComponent };